const menu = document.querySelector('div#menu');
const menuBreakpoint = 1200;

window.addEventListener("load", function() {
    //
    // ajustement de la largeur du menu pour garantir un rendu pixel-perfect (entier et pair)
    //
    const mq = window.matchMedia(`(min-width: ${menuBreakpoint}px)`);

    function fixMenuWidth() {
        if(!mq.matches) {
            menu.style.removeProperty('width');

            return;
        }

        const rect = menu.getBoundingClientRect();
        let w = Math.ceil(rect.width);

        if(w % 2 !== 0) {
            w += 1;
        }

        menu.style.setProperty('width', w + 'px', 'important');
    }

    fixMenuWidth();

    window.addEventListener('resize', fixMenuWidth);
    mq.addEventListener('change', fixMenuWidth);

    //
    // récupération du texte d'un lien
    //
    function getVisibleText(element) {
        return element ? element.textContent.trim() : '';
    }

    //
    // fermeture d'un élément de liste
    //
    function closeItem(item, force = false) {
        if(!force && window.innerWidth < menuBreakpoint) {
            return;
        }

        item.classList.remove('open', 'open-responsive');

        const button = item.querySelector('button.dropdown-toggle');
        const span = button ? button.querySelector('span.visually-hidden') : null;

        if(button) {
            const label = getVisibleText(button.previousElementSibling);

            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-label', 'Ouvrir le sous-menu "' + label + '"');

            if(span) {
                span.textContent = 'Ouvrir le sous-menu "' + label + '"';
            }
        }
    }

    //
    // configuration d'un bouton de dropdown
    //
    function initDropdownButton(button) {
        if(button) {
            const buttonLabel = getVisibleText(button.previousElementSibling);
            const span = button ? button.querySelector('span.visually-hidden') : null;

            button.setAttribute('tabindex', '0');
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-label', `Ouvrir le sous-menu "` + buttonLabel + `"`);

            if(span) {
                span.textContent = `Ouvrir le sous-menu "` + buttonLabel + `"`;
            }

            const li = button.closest('li');

            // ouverture d'un élément parent de liste
            function openParent(current) {
                let parent = current.parentElement.closest('li');

                while(parent) {
                    const openClass = window.innerWidth < menuBreakpoint ? 'open-responsive' : 'open';

                    if(!parent.classList.contains(openClass)) {
                        const parentButton = parent.querySelector('button.dropdown-toggle');
                        const parentSpan = parentButton ? parentButton.querySelector('span.visually-hidden') : null;

                        parent.classList.add(openClass);

                        if(parentButton) {
                            const label = getVisibleText(parentButton.previousElementSibling);

                            parentButton.setAttribute('aria-expanded', 'true');
                            parentButton.setAttribute('aria-label', `Fermer le sous-menu "` + label + `"`);

                            if(parentSpan) {
                                parentSpan.textContent = `Fermer le sous-menu "` + label + `"`;
                            }
                        }
                    }

                    parent = parent.parentElement.closest('li');
                }
            }

            // fermeture de tous les éléments de liste à la fermeture de l'élément parent de liste
            function closeChildren(parent) {
                const openClass = window.innerWidth < menuBreakpoint ? 'open-responsive' : 'open';

                parent.querySelectorAll('li.' + openClass).forEach(child => {
                    if(child !== parent) {
                        const childButton = child.querySelector('button.dropdown-toggle');
                        const childSpan = childButton ? childButton.querySelector('span.visually-hidden') : null;

                        child.classList.remove(openClass);

                        if(childButton) {
                            const label = getVisibleText(childButton.previousElementSibling);

                            childButton.setAttribute('aria-expanded', 'false');
                            childButton.setAttribute('aria-label', `Ouvrir le sous-menu "` + label + `"`);

                            if(childSpan) {
                                childSpan.textContent = `Ouvrir le sous-menu "` + label + `"`;
                            }
                        }
                    }
                });
            }

            // gestion du clic sur le bouton
            if(li) {
                button.addEventListener('click', function(e) {
                    e.stopPropagation();

                    let open;

                    if(window.innerWidth < menuBreakpoint) {
                        open = li.classList.toggle('open-responsive');
                    } else {
                        open = li.classList.toggle('open');
                    }

                    button.setAttribute('aria-expanded', open ? 'true' : 'false');
                    button.setAttribute('aria-label', (open ? `Fermer le sous-menu "` : `Ouvrir le sous-menu "`) + buttonLabel + `"`);

                    if(span) {
                        span.textContent = (open ? `Fermer le sous-menu "` : `Ouvrir le sous-menu "`) + buttonLabel + `"`;
                    }

                    if(open) {
                        openParent(li);
                    } else {
                        closeChildren(li);
                    }
                });
            }

            // gestion de la navigation au clavier
            if(li) {
                button.addEventListener('keydown', function(e) {
                    if(e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();

                        let open;

                        if(window.innerWidth < menuBreakpoint) {
                            open = li.classList.toggle('open-responsive');
                        } else {
                            open = li.classList.toggle('open');
                        }

                        button.setAttribute('aria-expanded', open ? 'true' : 'false');
                        button.setAttribute('aria-label', (open ? `Fermer le sous-menu "` : `Ouvrir le sous-menu "`) + buttonLabel + `"`);

                        if(span) {
                            span.textContent = (open ? `Fermer le sous-menu "` : `Ouvrir le sous-menu "`) + buttonLabel + `"`;
                        }

                        if(open) {
                            openParent(li);
                        } else {
                            closeChildren(li);
                        }
                    }
                });
            }

            // gestion de la perte de focus
            if(li) {
                li.addEventListener('focusout', function(e) {
                    const next = e.relatedTarget;

                    if(!next) {
                        return;
                    }

                    if(li.contains(next)) {
                        return;
                    }

                    const nextLi = next.closest('li');

                    if(nextLi && (nextLi.contains(li) || li.contains(nextLi))) {
                        return;
                    }

                    closeItem(li);
                });
            }
        }
    }

    //
    // initialisation de tous les boutons de sous-menu
    //
    menu.querySelectorAll('button.dropdown-toggle').forEach(initDropdownButton);

    //
    // fermeture des éléments de liste ouverts lors du survol d'un autre élément de liste
    //
    menu.querySelectorAll('li').forEach(li => {
        li.addEventListener('mouseenter', function() {
            if(window.innerWidth < menuBreakpoint) {
                return;
            }

            menu.querySelectorAll('li.open').forEach(item => {
                if(!item.contains(li) && !li.contains(item)) {
                    closeItem(item);
                }
            });
        });
    });

    //
    // fermeture des éléments de liste ouverts lors d'un clic en dehors
    //
    document.addEventListener('click', function(e) {
        menu.querySelectorAll('li.' + (window.innerWidth < menuBreakpoint ? 'open-responsive' : 'open')).forEach(item => {
            if(!item.contains(e.target)) {
                closeItem(item);
            }
        });
    });

    //
    // fermeture du menu et de tous les sous-menus lors du redimensionnement de la fenêtre
    //
    let wasMobile = window.innerWidth < menuBreakpoint;

    window.addEventListener('resize', () => {
        const isMobile = window.innerWidth < menuBreakpoint;

        if(wasMobile !== isMobile) {
            menu.querySelectorAll('li.open', 'li.open-responsive').forEach(item =>
                closeItem(item, {
                    force: true,
                })
            );
        }

        wasMobile = isMobile;
    });
});

//
// duplication des entrées du menu du header dans le menu
//
const ul = document.querySelector('header .navbar ul.menu-depth-0');

document.querySelector('header .navbar .offcanvas').addEventListener('show.bs.offcanvas', function() {
    if(ul.querySelector('.d-xl-none')) {
        return;
    }

    const items = Array.from(document.querySelector('header .menu').querySelectorAll(':scope > li'));
    const total = items.length;

    items.forEach((li, index) => {
        const clone = li.cloneNode(true);
        clone.removeAttribute('id');

        const link = clone.querySelector('a');

        if(link) {
            const hasClasses = ['btn', 'btn-arrow', 'btn-secondary'].every(cls => link.classList.contains(cls));

            link.className = '';

            if(hasClasses) {
                link.classList.add('btn', 'btn-secondary');
            } else {
                link.classList.add('btn', 'btn-tertiary');
            }

            const wrapper = document.createElement('div');

            link.parentNode.insertBefore(wrapper, link);
            wrapper.appendChild(link);
        }

        clone.classList.add('d-xl-none', 'nav-item');

        if(index >= total - 2) {
            ul.appendChild(clone);
        } else {
            ul.insertBefore(clone, ul.firstChild);
        }
    });
});